// eventEmitter.js
//监听登录状态
import EventEmitter from 'events';

const eventEmitter = new EventEmitter();
export default eventEmitter;
